<header >
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>


<div class="body" >
    <span >
    <label class="catlabel" *ngIf="eventType == 'warning'"> ETA Date is Past Date . Do you want to confirm ?</label>
    <label class="catlabel" *ngIf="eventType == 'delete'"> Waybill Number : {{waybill}}</label>
    <label class="catlabel" *ngIf="eventType == 'deleteLoadType'"> Menu option : {{menuOption}} </label>
    <label class="catlabel" *ngIf="eventType == 'deleteLoadType'"> Dock : {{dataStore.data[0]?.dock_code }}</label>
    <label class="catlabel" *ngIf="eventType == 'deleteLoadType'"> Load Type : {{dataStore.data[0]?.load_types }}</label>
    <label class="catlabel" *ngIf="eventType == 'deleteContainer'"> Container Number : {{dataStore.data[0]?.container}} </label>
    <label class="catlabel" *ngIf="eventType == 'reopenContainer'"> Container Number : {{dataStore.data[0]?.container}} </label>
    <!-- <label class="catlabel" *ngIf="eventType == 'deleteContainer'"> Renban : {{dataStore.data[0]?.renban }}</label>
    <label class="catlabel" *ngIf="eventType == 'deleteContainer'"> Waybill No : {{dataStore.data[0]?.waybill }}</label> -->
    </span>
</div>


<div class="footerp" style="position: relative;top: 14px;" >
    <span (click)="close()" class="cancel" style="display: inline; background: transparent;border: none !important;padding-left: 21px;position: relative;
        top: 10px;"> CANCEL </span>
    <button mat-raised-button class="submit submit1" style="display: inline;" (click)="confirm()">CONFIRM</button>
</div>
